/**
 * Projiziert eine 3D-Weltposition auf 2D-Bildschirmkoordinaten.
 * Nutzt Camera View/Projection-Matrizen und Canvas-Größe.
 */

import type { Camera } from '../renderer/Camera';

export interface ScreenPos { x: number; y: number }

const _scratch: ScreenPos = { x: 0, y: 0 };

/**
 * Projiziert Weltkoordinaten (x, y, z) auf Bildschirmpixel.
 * Gibt null zurück wenn der Punkt hinter der Kamera liegt.
 * Achtung: gibt ein geteiltes Scratch-Objekt zurück — Werte kopieren!
 */
export function worldToScreen(
  camera: Camera, canvas: HTMLCanvasElement,
  x: number, y: number, z: number,
): ScreenPos | null {
  const vd = camera.view.data;
  const pd = camera.projection.data;

  // View-Transform
  const ex = vd[0] * x + vd[4] * y + vd[8] * z + vd[12];
  const ey = vd[1] * x + vd[5] * y + vd[9] * z + vd[13];
  const ez = vd[2] * x + vd[6] * y + vd[10] * z + vd[14];
  const ew = vd[3] * x + vd[7] * y + vd[11] * z + vd[15];

  // Projection-Transform
  const px = pd[0] * ex + pd[4] * ey + pd[8] * ez + pd[12] * ew;
  const py = pd[1] * ex + pd[5] * ey + pd[9] * ez + pd[13] * ew;
  const pw = pd[3] * ex + pd[7] * ey + pd[11] * ez + pd[15] * ew;

  if (pw <= 0) return null;

  _scratch.x = (px / pw * 0.5 + 0.5) * canvas.clientWidth;
  _scratch.y = (-py / pw * 0.5 + 0.5) * canvas.clientHeight;
  return _scratch;
}
